import { render } from "./PropertyLivestock.vue?vue&type=template&id=8010b976"
import script from "./PropertyLivestock.vue?vue&type=script&lang=js"
export * from "./PropertyLivestock.vue?vue&type=script&lang=js"

import "./PropertyLivestock.vue?vue&type=style&index=0&id=8010b976&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__